import React, { ReactElement } from 'react';
import { Button, DatePicker, Space } from 'antd';
import { Moment } from 'moment';
import { isEmpty } from 'lodash';

import { FieldLocationStyled } from 'leash/components/fields/fieldLocation/FieldLocation.styles';
import { usePackagesContext } from 'leash/context/packages/PackagesContext';
import date, { US_LOCALE_DATE_FORMAT } from 'utilities/dates/date';

type Props = {
  onClear: () => void;
  onSearch: (selectedKeys: React.Key[], dataIndex: string) => void;
  values?: {
    departureDate?: string;
    arrivalDate?: string;
    departureLocation?: string;
    arrivalLocation?: string;
  };
};

export const PackageFilters = ({ values, onClear, onSearch }: Props): ReactElement => {
  const {
    state: { filters },
  } = usePackagesContext();
  const isFiltersEmpty = Object.values(filters).every((x) => x === null || isEmpty(x));

  const handleDateChange = (value: Moment | null, dataIndex: string) => {
    onSearch(value ? [value.format()] : [], dataIndex);
  };

  const handleFacetChange = (value: string, dataIndex: string) => {
    onSearch(value ? [value] : [], dataIndex);
  };

  return (
    <Space size="middle" align="center" data-testid="package-filters">
      <span>Filter by:</span>
      <DatePicker
        placeholder="Departure date"
        data-testid="package-filters-date-departure"
        format={US_LOCALE_DATE_FORMAT}
        value={date.getMomentObject(values?.departureDate)}
        onChange={(value) =>
          handleDateChange(value, 'travelPackage.travelProposal.departureTime')
        }
      />
      <DatePicker
        placeholder="Arrival date"
        data-testid="package-filters-date-arrival"
        format={US_LOCALE_DATE_FORMAT}
        value={date.getMomentObject(values?.arrivalDate)}
        onChange={(value) =>
          handleDateChange(value, 'travelPackage.travelProposal.arrivalTime')
        }
      />
      <FieldLocationStyled
        placeholder="Departure location"
        data-testid="filters-location-departure"
        value={values?.departureLocation}
        onChange={(stateAbbr) => handleFacetChange(stateAbbr, 'breeder.stateAbbr')}
      />
      <FieldLocationStyled
        placeholder="Arrival location"
        data-testid="package-filters-location-arrival"
        value={values?.arrivalLocation}
        onChange={(stateAbbr) => handleFacetChange(stateAbbr, 'customer.stateAbbr')}
      />
      <Button
        ghost
        type="primary"
        onClick={onClear}
        disabled={isFiltersEmpty}
        data-testid="clear-filters"
      >
        Clear filters
      </Button>
    </Space>
  );
};
